import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-product-edit-banner-title',
  templateUrl: './product-edit-banner-title.component.html',
  styleUrls: ['./product-edit-banner-title.component.css']
})
export class ProductEditBannerTitleComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
